import { ITransactionAdjustment } from "../interfaces/ITransactionAdjustment";

export class AdjustmentModalDTO{
    transactionId: string;
    cardId: string;
    cardholderId: string;
    transactionDate: string;
    transactionAmount: number;
    adjustment?: ITransactionAdjustment

    constructor(
        transactionId: string,
        cardId: string,
        cardholderId: string,
        transactionDate: string,
        transactionAmount: number,
        adjustment: ITransactionAdjustment
      ) {
        this.transactionId = transactionId;
        this.cardId = cardId;
        this.cardholderId = cardholderId;
        this.transactionDate = transactionDate;
        this.adjustment = adjustment;
        this.transactionDate = transactionDate;
        this.transactionAmount = transactionAmount;
      }
}